import * as Yup from 'yup'

export const profileSchema = (showPassword: boolean, isMedico?: boolean) =>
  Yup.object().shape({
    password:
      isMedico && showPassword
        ? Yup.string().required('Senha é obrigatória')
        : Yup.string().notRequired(),
    email: Yup.string()
      .email('Formato inválido')
      .min(3, 'Minimo de 5 caracteres')
      .max(50, 'Máximo de 50 caracteres')
      .required('O campo e-mail é obrigatório'),
    pessoa: Yup.object().shape({
      id: Yup.number(),
      primeiroNome: Yup.string()
        .min(3, 'Minimo de 5 caracteres')
        .max(50, 'Máximo de 50 caracteres')
        .required('O campo primeiroNome é obrigatório'),
      sobreNome: Yup.string()
        .min(3, 'Minimo de 5 caracteres')
        .max(50, 'Máximo de 50 caracteres')
        .required('O campo sobrenome é obrigatório'),
      cpf: Yup.string().required('O campo CPF é obrigatório'),
      dataNascimento: Yup.string().required('O campo data de nascimento é obrigatório'),
      telefone: Yup.string()
        .matches(
          /^\(\d{2}\) (\d )?\d{4}-\d{4}$/,
          'Formato deve ser (00) 0000-0000 ou (00) 0 0000-0000'
        )
        .notRequired(),
    }),
  })
